if (!customElements.get("bdt-mifu-pefu")) {
  customElements.define(
    "bdt-mifu-pefu",
    class bdtv_38440ac721b4 extends HTMLElement {
      constructor() {
        super();
        this.countdownBtn = this.closest("div")?.querySelector("div.countdown-btn a"
        );
        this.countdownAppend = this.querySelector(".bdt-mifu-nucleo");
        this.init();
      }

      init() {
        const bdtv_73aca891942f = this.dataset?.bdtNofu;
        const bdtv_aff41a4824ba = this.dataset?.bdtNofuPuro;
        const bdtv_c23bdbb93fdf = this.dataset?.bdtSegu;
        const bdtv_581468202d5e = this.dataset?.bdtOculto2;
        const bdtv_dbfa19eef3a9 = this.dataset?.bdtKibe;
        const bdtv_dd8efb08c656 = this.dataset?.bdtContorno;
        

        let bdtv_5ae8466c230c = {};
        if (bdtv_73aca891942f) {
          let bdtv_519b638046e4 = "";
          if (this.isISODate(bdtv_73aca891942f)) {
            bdtv_519b638046e4 = bdtv_73aca891942f;
            this.mainFunction(bdtv_519b638046e4, false, bdtv_c23bdbb93fdf, bdtv_581468202d5e, bdtv_dbfa19eef3a9, bdtv_dd8efb08c656);
          } else {
            if (this.isValidDate(bdtv_73aca891942f)) {
              const bdtv_7134774c0167 = bdtv_73aca891942f.split("-");
              bdtv_519b638046e4 =
                bdtv_7134774c0167[2] +
                "-" +
                bdtv_7134774c0167[0].padStart(2, "0") +
                "-" +
                bdtv_7134774c0167[1].padStart(2, "0") +
                "T00:00:00Z";
              this.mainFunction(bdtv_519b638046e4, false, bdtv_c23bdbb93fdf, bdtv_581468202d5e, bdtv_dbfa19eef3a9, bdtv_dd8efb08c656);
            } else {
              if (bdtv_c23bdbb93fdf) {
                this.innerHTML =
                  this.appendChildHtmlTimeOut(bdtv_c23bdbb93fdf).innerHTML;
              } else {
                this.innerHTML = this.appendChildHtml(bdtv_aff41a4824ba, bdtv_581468202d5e, bdtv_dbfa19eef3a9, bdtv_dd8efb08c656).innerHTML;
                bdtv_5ae8466c230c = {
                  "bdt-kuli": 0,
                  "bdt-faki": 0,
                  "bdt-bume": 0,
                  "bdt-vafi": 0,
                };
                Object.entries(bdtv_5ae8466c230c).forEach(([bdtv_7351a1927b10, bdtv_ba7a097051a6]) => {
                  this.querySelector("." + bdtv_7351a1927b10).innerHTML = bdtv_ba7a097051a6
                    .toString()
                    .padStart(2, "0");
                });
              }
              this.countdownBtn?.setAttribute("aria-disabled", true);
            }
          }
        } else if (bdtv_aff41a4824ba) {
          let bdtv_7e3745e0a3dc = "";
          this.mainFunction(bdtv_7e3745e0a3dc, bdtv_aff41a4824ba, bdtv_c23bdbb93fdf, bdtv_581468202d5e, bdtv_dbfa19eef3a9, bdtv_dd8efb08c656);
        } else {
          if (bdtv_c23bdbb93fdf) {
            this.innerHTML =
              this.appendChildHtmlTimeOut(bdtv_c23bdbb93fdf).innerHTML;
          } else {
            this.innerHTML = this.appendChildHtml(bdtv_aff41a4824ba, bdtv_581468202d5e, bdtv_dbfa19eef3a9, bdtv_dd8efb08c656).innerHTML;
            bdtv_5ae8466c230c = {
              "bdt-kuli": 0,
              "bdt-faki": 0,
              "bdt-bume": 0,
              "bdt-vafi": 0,
            };
            Object.entries(bdtv_5ae8466c230c).forEach(([bdtv_ffd0162b2af9, bdtv_72ee2e94ea84]) => {
              this.querySelector("." + bdtv_ffd0162b2af9).innerHTML = bdtv_72ee2e94ea84
                .toString()
                .padStart(2, "0");
            });
          }
          this.countdownBtn?.setAttribute("aria-disabled", true);
        }
      }

      mainFunction(bdtv_e1fa0387cdbd, bdtv_65f3cebaf4cc, bdtv_4f61c8652e0f, bdtv_14e2bf960880, bdtv_dc02ac7e7615, bdtv_35ccbcdc918c) {
        let bdtv_800559008629 = {};
        if (Date.parse(bdtv_e1fa0387cdbd) || bdtv_65f3cebaf4cc) {
          let bdtv_c304b5c94bee = new Date(bdtv_e1fa0387cdbd);
          if (bdtv_65f3cebaf4cc) {
            bdtv_c304b5c94bee = new Date(Date.now() + parseInt(bdtv_65f3cebaf4cc) * 60000);
          }

          const bdtv_d3215c6b8614 = () => {
            let bdtv_9589aef2666a = +bdtv_c304b5c94bee - +new Date();
            if (bdtv_9589aef2666a > 0) {
              if (bdtv_65f3cebaf4cc) {
                this.countdownAppend.innerHTML =
                  this.appendChildHtml(bdtv_65f3cebaf4cc, bdtv_14e2bf960880, bdtv_dc02ac7e7615, bdtv_35ccbcdc918c).innerHTML;
              } else {
                this.innerHTML = this.appendChildHtml(bdtv_65f3cebaf4cc, bdtv_14e2bf960880, bdtv_dc02ac7e7615, bdtv_35ccbcdc918c).innerHTML;
              }
              bdtv_800559008629 = {
                "bdt-kuli": Math.floor(bdtv_9589aef2666a / (1000 * 60 * 60 * 24)),
                "bdt-faki": Math.floor((bdtv_9589aef2666a / (1000 * 60 * 60)) % 24),
                "bdt-bume": Math.floor((bdtv_9589aef2666a / 1000 / 60) % 60),
                "bdt-vafi": Math.floor((bdtv_9589aef2666a / 1000) % 60),
              };
            } else {
              if (bdtv_4f61c8652e0f) {
                this.innerHTML =
                  this.appendChildHtmlTimeOut(bdtv_4f61c8652e0f).innerHTML;
              } else {
                this.innerHTML = this.appendChildHtml(bdtv_65f3cebaf4cc, bdtv_14e2bf960880, bdtv_dc02ac7e7615, bdtv_35ccbcdc918c).innerHTML;
                bdtv_9589aef2666a = 0;
                bdtv_800559008629 = {
                  "bdt-kuli": 0,
                  "bdt-faki": 0,
                  "bdt-bume": 0,
                  "bdt-vafi": 0,
                };
              }
              this.countdownBtn?.setAttribute("aria-disabled", true);
            }
            return bdtv_800559008629;
          };

          const bdtv_d2033e043078 = () => {
            const bdtv_e57772965823 = bdtv_d3215c6b8614();
            Object.entries(bdtv_e57772965823).forEach(([bdtv_8cdbce3768c4, bdtv_2ba5b7f20504]) => {
              if (this.querySelector("." + bdtv_8cdbce3768c4)) {
                this.querySelector("." + bdtv_8cdbce3768c4).innerHTML = bdtv_2ba5b7f20504
                  .toString()
                  .padStart(2, "0");
              }
            });
          };
          setInterval(bdtv_d2033e043078, 1000);
        } else {
          if (bdtv_4f61c8652e0f) {
            this.innerHTML =
              this.appendChildHtmlTimeOut(bdtv_4f61c8652e0f).innerHTML;
          } else {
            this.innerHTML = this.appendChildHtml(bdtv_65f3cebaf4cc, bdtv_14e2bf960880, bdtv_dc02ac7e7615, bdtv_35ccbcdc918c).innerHTML;
            bdtv_800559008629 = {
              "bdt-kuli": 0,
              "bdt-faki": 0,
              "bdt-bume": 0,
              "bdt-vafi": 0,
            };
            Object.entries(bdtv_800559008629).forEach(([bdtv_3470e6c60c69, bdtv_dd34e5b7c5d8]) => {
              this.querySelector("." + bdtv_3470e6c60c69).innerHTML = bdtv_dd34e5b7c5d8
                .toString()
                .padStart(2, "0");
            });
          }
          this.countdownBtn?.setAttribute("aria-disabled", true);
        }
      }

      appendChildHtml(bdtv_1ad7f73ed390, bdtv_caf472a74af0, bdtv_930504e6a1ca, bdtv_8c96a51dc35b) {
        const bdtv_22d56714cfed = this.dataset?.bdtDe;
        const bdtv_dbb00b3ea3b3 = this.dataset?.bdtKobi;
        const bdtv_efb0cf5804f9 = this.dataset?.bdtPuro;
        const bdtv_950b191b2003 = this.dataset?.bdtGiko;

        const bdtv_531d0769d051 = (bdtv_6eb1e14dc46e) => {
          if (bdtv_6eb1e14dc46e === "rounded") return "bdt-pare-5";
          if (bdtv_6eb1e14dc46e === "circle") return "bdt-pare-tire";
          return "";
        };
        const bdtv_336c3ab0b526 = bdtv_531d0769d051(bdtv_930504e6a1ca);

        const bdtv_188fdb04b169 = (bdtv_10cc63311c2c) => {
          if (bdtv_10cc63311c2c === "solid") return " border-style";
          if (bdtv_10cc63311c2c === "none") return "";
        };
        const bdtv_62d679b59198 = bdtv_188fdb04b169(bdtv_8c96a51dc35b);

        const bdtv_02d53eb40ff7 = document.createElement("div");
        bdtv_02d53eb40ff7.innerHTML = `
          <div class="bdt-mifu-moldura bdt-zi-sove${bdtv_caf472a74af0 != "false" ? "" : " bdt-verbo-color bdt-te-proprio"} bdt-di-w-proprio bdt-p-proprio${(bdtv_1ad7f73ed390 && bdtv_caf472a74af0 != "false") ? " bdt-oculto2" : ""} bdt-fi bdt-coluna ${bdtv_336c3ab0b526}${bdtv_62d679b59198} bdt-daku bdt-corpo-centro2">
            <span class="bdt-kuli bdt-mifu-unidade bdt-feza bdt-pe-custom"></span>
            <span class="bdt-pe-13 bdt-de bdt-pefu-ridu-verbo${bdtv_caf472a74af0 != "false" ? "" : ""}">${bdtv_22d56714cfed || "days"}</span>
          </div>
          <div class="bdt-mifu-moldura bdt-zi-sove${bdtv_caf472a74af0 != "false" ? "" : " bdt-verbo-color bdt-te-proprio"} bdt-di-w-proprio bdt-p-proprio${(bdtv_1ad7f73ed390 && bdtv_caf472a74af0 != "false") ? " bdt-oculto2" : ""} bdt-fi bdt-coluna ${bdtv_336c3ab0b526}${bdtv_62d679b59198} bdt-daku bdt-corpo-centro2">
            <span class="bdt-faki bdt-mifu-unidade bdt-feza bdt-pe-custom"></span>
            <span class="bdt-pe-13 bdt-kobi bdt-pefu-ridu-verbo${bdtv_caf472a74af0 != "false" ? " " : ""}">${bdtv_dbb00b3ea3b3 || "hours"}</span>
          </div>
          <div class="bdt-mifu-moldura bdt-zi-sove${bdtv_caf472a74af0 != "false" ? "" : " bdt-verbo-color bdt-te-proprio"} bdt-di-w-proprio bdt-p-proprio bdt-fi bdt-coluna ${bdtv_336c3ab0b526}${bdtv_62d679b59198} bdt-daku bdt-corpo-centro2">
            <span class="bdt-bume bdt-mifu-unidade bdt-feza bdt-pe-custom"></span>
            <span class="bdt-pe-13 bdt-tude bdt-pefu-ridu-verbo${bdtv_caf472a74af0 != "false" ? " " : ""}">${bdtv_efb0cf5804f9 || "mins"}</span>
          </div>
          <div class="bdt-mifu-moldura bdt-zi-sove${bdtv_caf472a74af0 != "false" ? "" : " bdt-verbo-color bdt-te-proprio"} bdt-di-w-proprio bdt-p-proprio bdt-fi bdt-coluna ${bdtv_336c3ab0b526}${bdtv_62d679b59198} bdt-daku bdt-corpo-centro2">
            <span class="bdt-vafi bdt-mifu-unidade bdt-feza bdt-pe-custom"></span>
            <span class="bdt-pe-13 bdt-nana bdt-pefu-ridu-verbo${bdtv_caf472a74af0 != "false" ? "" : ""}">${bdtv_950b191b2003 || "secs"}</span>
          </div>`;
        return bdtv_02d53eb40ff7;
      }

      appendChildHtmlTimeOut(bdtv_8d9d965b36b4) {
        const bdtv_a57ca612fb56 = document.createElement("div");
        bdtv_a57ca612fb56.innerHTML = `<span class="timeout">${bdtv_8d9d965b36b4}</span>`;
        return bdtv_a57ca612fb56;
      }

      isISODate(bdtv_d5d9aee291a5) {
        const bdtv_069d9790cf04 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
        return bdtv_069d9790cf04.test(bdtv_d5d9aee291a5);
      }

      isValidDate(bdtv_ac321a9d16a2) {
        return /^\d{2}-\d{2}-\d{4}$/.test(bdtv_ac321a9d16a2);
      }
    }
  );
}
 